// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__erdL0","label":"Labeled_label__2sg_j","divider":"Labeled_divider__1qAPY"};